<script lang="ts">
  import { observe } from "$lib/actions/observe";
  import HOTELMOCCA from "$lib/images/portfolio/hotelmocca.png?enhanced";
  import HAUSUNDPARTNER from "$lib/images/portfolio/hausundpartner.jpg?enhanced";
  import DRIMAN from "$lib/images/portfolio/driman.jpg?enhanced";
  import TUPO from "$lib/images/portfolio/Tupo.png?enhanced";
  import HALAWAH from "$lib/images/portfolio/halawah.jpg?enhanced";
  import MOEBELPACKER from "$lib/images/portfolio/diemoebelpacker.jpg?enhanced";
  import EMASBG from "$lib/images/portfolio/ema-sbg.webp?enhanced";
  import SOURCE387 from "$lib/images/portfolio/source387.jpg?enhanced";

  const ImageSources: Record<string, typeof HOTELMOCCA> = {
    hotelmocca: HOTELMOCCA,
    hausundpartner: HAUSUNDPARTNER,
    driman: DRIMAN,
    tupo: TUPO,
    halawah: HALAWAH,
    moebelpacker: MOEBELPACKER,
    emasbg: EMASBG,
    source387: SOURCE387
  };

  let {
    sectionLabel = "",
    headline = "",
    description = "",
    projects = [] as Array<{
      thumb: string;
      tags: string[];
      title: string;
      description: string;
      linkText?: string;
      linkHref?: string;
      dataService?: string;
    }>,
    showFilter = false,
    allLink = "",
    allLinkText = "",
    filter = "all"
  } = $props();

  let activeFilter = $state("all");

  $effect(() => {
    activeFilter = filter;
  });

  const filtered = $derived(showFilter && activeFilter !== "all" ? projects.filter((p) => p.dataService?.includes(activeFilter)) : projects);

  function setFilter(f: string) {
    activeFilter = f;
  }
</script>

<section>
  <div class="container">
    <div class="section-divider fade-up" use:observe>
      {#if sectionLabel}
        <span class="section-label">{sectionLabel}</span>
      {/if}
      <h2>{headline}</h2>
      {#if description}
        <p>{description}</p>
      {/if}
    </div>

    {#if showFilter}
      <div class="filter-bar fade-up" use:observe role="group" aria-label="Projekte filtern">
        <button class="filter-btn" class:active={activeFilter === "all"} aria-pressed={activeFilter === "all"} onclick={() => setFilter("all")}>Alle</button>
        <button class="filter-btn" class:active={activeFilter === "design"} aria-pressed={activeFilter === "design"} onclick={() => setFilter("design")}>Webdesign</button>
        <button class="filter-btn" class:active={activeFilter === "development"} aria-pressed={activeFilter === "development"} onclick={() => setFilter("development")}>Development</button>
        <button class="filter-btn" class:active={activeFilter === "jamstack"} aria-pressed={activeFilter === "jamstack"} onclick={() => setFilter("jamstack")}>JamStack</button>
        <button class="filter-btn" class:active={activeFilter === "seo"} aria-pressed={activeFilter === "seo"} onclick={() => setFilter("seo")}>SEO</button>
        <button class="filter-btn" class:active={activeFilter === "ecommerce"} aria-pressed={activeFilter === "ecommerce"} onclick={() => setFilter("ecommerce")}>Ecommerce</button>
      </div>
    {/if}

    <div class="portfolio-grid stagger" use:observe>
      {#each filtered as project}
        <div class="card portfolio-card">
          <a href={project.linkHref || "/"} target="_blank" rel="noopener" class="card-thumb" tabindex="-1" aria-hidden="true">
            {#if ImageSources[project.thumb]}
              <enhanced:img src={ImageSources[project.thumb]} alt={project.title} />
            {:else}
              {project.thumb}
            {/if}
          </a>
          {#if project.tags.length}
            <div class="tags">
              {#each project.tags as tag}
                <span class="tag">{tag}</span>
              {/each}
            </div>
          {/if}
          <h3>{project.title}</h3>
          <p>{project.description}</p>
          {#if project.linkText}
            <a href={project.linkHref || "#"} target="_blank" class="btn btn-ghost mt-1" style="font-size:0.875rem">
              {project.linkText} <span class="accent">→</span>
            </a>
          {/if}
        </div>
      {/each}
    </div>

    {#if allLink}
      <div class="text-center mt-2 fade-up" use:observe>
        <a href={allLink} class="btn btn-outline">{allLinkText || "Alle Projekte ansehen"} →</a>
      </div>
    {/if}
  </div>
</section>
